module.exports = __webpack_public_path__ + "assets/img/38.29ede71e.png";